import { ArrowRight, Boxes, Headphones, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

const upgrades = {
  growth: { limit: 20_000, name: "Scale" },
  solo: { limit: 1_000, name: "Starter" },
  starter: { limit: 5_000, name: "Growth" },
};

export function ProductLimitUpgradeDialog({ error, onOpenChange }) {
  const navigate = useNavigate();
  const upgrade = error ? upgrades[String(error.planId).toLowerCase()] : null;
  const isScale = Boolean(error && !upgrade);

  const continueToUpgrade = () => {
    onOpenChange(false);
    navigate(isScale ? "/support" : "/subscription");
  };

  return (
    <Dialog open={Boolean(error)} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[540px] overflow-hidden border-0 bg-card p-0 shadow-2xl sm:rounded-[28px]">
        <div className="relative overflow-hidden bg-gradient-to-br from-primary via-primary to-emerald-800 px-7 pb-8 pt-7 text-primary-foreground">
          <div className="absolute -right-16 -top-20 h-52 w-52 rounded-full bg-white/10" />
          <div className="absolute -bottom-24 left-16 h-48 w-48 rounded-full bg-cyan-300/10" />
          <div className="relative">
            <div className="mb-8 flex h-12 w-12 items-center justify-center rounded-2xl border border-white/20 bg-white/15 shadow-lg">
              <Sparkles className="h-6 w-6" />
            </div>
            <DialogTitle className="max-w-sm text-3xl font-semibold leading-tight tracking-tight">
              Your catalogue is growing
            </DialogTitle>
            <DialogDescription className="mt-3 max-w-md text-sm leading-6 text-primary-foreground/80">
              You have reached the {Number(error?.limit || 0).toLocaleString()} active-product limit on {error?.planName || "your current plan"}.
            </DialogDescription>
          </div>
        </div>

        <div className="space-y-5 px-7 pb-7 pt-6">
          <div className="flex items-start gap-4 rounded-2xl border border-primary/15 bg-primary/5 p-4">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary text-primary-foreground">
              {isScale ? <Headphones className="h-5 w-5" /> : <Boxes className="h-5 w-5" />}
            </div>
            <div>
              <div className="font-semibold text-foreground">
                {isScale ? "Need more capacity?" : `Move up to ${upgrade?.name}`}
              </div>
              <p className="mt-1 text-sm leading-5 text-muted-foreground">
                {isScale
                  ? "Talk to our team about capacity tailored to your operation."
                  : `Create up to ${upgrade?.limit.toLocaleString()} active products and keep expanding without interruption.`}
              </p>
            </div>
          </div>
          <Button className="h-12 w-full rounded-xl text-sm font-semibold" onClick={continueToUpgrade}>
            {isScale ? "Contact support" : "Explore upgrade options"}
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <button className="w-full text-sm font-medium text-muted-foreground hover:text-foreground" onClick={() => onOpenChange(false)} type="button">
            Not now
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
